import React from 'react';
import axios from 'axios';
import { Form, Select } from 'antd';

import apiPath from 'apiPath';

export default class ProvinceSelect extends React.Component {
	state = {
		country: null,
		options: [],
		optionsLoaded: false
	}
	handleCountryChange = (countryCode) => {
		if (!countryCode || countryCode === this.state.country || countryCode === '') return;
		this.setState({ optionsLoaded: false });
		axios.get(apiPath + '/dictionary/PRV/' + countryCode).then(result => {
			this.setState({ options: result.data.filter(option => option.Code !== null).sort((a,b) => {
				return a.Name.localeCompare(b.Name);
			}), optionsLoaded: true });
			this.setState({ country: countryCode });
		}).catch(error => {
			console.error(error);
		});
	}
	componentDidMount() {
		this.handleCountryChange(this.props.countryCode);
	}
	componentWillReceiveProps(nextProps) {
		this.handleCountryChange(nextProps.countryCode);
	}
	render() {
		const { getFieldDecorator, label, field, formItemLayout, disabled, prefix } = this.props;
		let initialValue = this.props.initialValue;
		if (this.state.optionsLoaded) {
			let initialOption = this.state.options.find(option => option.Name === initialValue);
			if (initialOption) initialValue = initialOption.Code;
		}
		return (
			<Form.Item label={label} className={this.props.className} {...formItemLayout}>
				{typeof getFieldDecorator === 'function' && getFieldDecorator(prefix+field, {
					initialValue: initialValue,
					rules: (this.props.required && this.state.optionsLoaded && this.state.options.length > 0) ? [{required: true, message: 'This field is required'}] : null
				})(
					<Select mode="combobox" allowClear
						placeholder={(disabled) ? '' : 'State/Province'}
						notFoundContent="No states/provinces found"
						onChange={this.props.onChange}
						onBlur={() => {
							if (!this.state.options.find(option => option.Code === this.props.form.getFieldValue(prefix+field))) {
								this.props.form.resetFields([prefix+field]);
							}
						}}
						disabled={disabled}
						filterOption={(inputValue, option) => {
							return option.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
						}}
						optionLabelProp="children">
						{this.state.options.map(option => {
							return (
								<Select.Option
									key={option.Code}
									title={option.Name}>
									{(this.props.showAbbreviations)? option.Name+' ('+option.Code+')': option.Name}
								</Select.Option>
							);
						})}
					</Select>
				)}
			</Form.Item>
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/ProvinceSelect/index.jsx